import { Link } from "react-router-dom";
import "../../../assets/css/overlay.css";
import logo from "../../../assets/img/new_ss_logo.png";
import Loader from "../../../components/loader";
import Auth from "../../../services/auth";
import { altAttribute } from "../../../utils/utils";
import PublicPageStyles from "./shared/PublicPageStyles";
import SimulationCard from "./shared/SimulationCard";
import SimulationLibrarySidebar from "./shared/SimulationLibrarySidebar";
import useSimulationLibrary from "./shared/useSimulationLibrary";

const getAccountId = () => {
  const role = Auth.getUserRole();
  if (role === "Role_Admin") {
    const user = Auth.getUserDetails();
    return user?.accId ?? 0;
  }
  return 0;
};

const ListPublicSimulations = () => {
  const {
    sims,
    loading,
    loadingMore,
    search,
    selectedFilters,
    isShowLastTwelveMonths,
    filterOptions,
    handleSearchInput,
    handleSearch,
    handleFilterClick,
    handleChangeLastMonth,
  } = useSimulationLibrary({
    useAppService: true,
    account: getAccountId(),
  });

  return (
    <div className="page-template page-template-list page-template-list-php page-id-54 wp-custom-logo wp-embed-responsive group-blog">
      <PublicPageStyles />

      <div className="site" id="page">
        <div id="wrapper-navbar">
          <a className="skip-link sr-only sr-only-focusable" href="#content">
            Skip to content
          </a>
          <nav className="navbar navbar-expand-md navbar-light main-nav">
            <div className="container">
              <a
                href="https://www.schoolsims.com"
                className="navbar-brand custom-logo-link"
                rel="home"
              >
                <img
                  width="250"
                  src={logo}
                  className="img-fluid"
                  alt={altAttribute.logoAlt}
                />
              </a>
              <button
                className="navbar-toggler buttons"
                type="button"
                data-toggle="collapse"
                data-target="#navbarNavDropdown"
                aria-controls="navbarNavDropdown"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon" />{" "}
              </button>
              <div className="nav-interface">
                <div
                  id="navbarNavDropdown"
                  className="collapse navbar-collapse"
                >
                  <ul id="main-menu" className="navbar-nav ml-auto">
                    <li
                      id="menu-item-51"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-51 nav-item"
                    >
                      {!Auth.isLoggedIn() && (
                        <a
                          title="Home"
                          href="https://www.schoolsims.com/"
                          className="nav-link"
                        >
                          Home
                        </a>
                      )}
                      {Auth.isLoggedIn() && (
                        <Link title="Home" to="/dashboard" className="nav-link">
                          Home
                        </Link>
                      )}
                    </li>
                    <li
                      id="menu-item-62"
                      className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-54 current_page_item active menu-item-62 nav-item"
                    >
                      <a
                        title="Simulations"
                        href="https://www.schoolsims.com/simulations/"
                        className="nav-link"
                      >
                        Simulations
                      </a>
                    </li>
                    <li
                      id="menu-item-606"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-606 nav-item"
                    >
                      <a
                        title="About"
                        href="https://www.schoolsims.com/about/"
                        className="nav-link"
                      >
                        About
                      </a>
                    </li>
                    <li
                      id="menu-item-156"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-156 nav-item"
                    >
                      <a
                        title="Blog"
                        href="https://www.schoolsims.com/blog/"
                        className="nav-link"
                      >
                        Blog
                      </a>
                    </li>
                    <li
                      id="menu-item-60"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-60 nav-item"
                    >
                      <a
                        title="Contact Us"
                        href="https://www.schoolsims.com/contact/"
                        className="nav-link"
                      >
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </nav>
        </div>

        <div className="wrapper">
          <section className="simulation-header p-0">
            <h3 className="title">Simulation Library</h3>
          </section>
          <section className="simulations-section p-0">
            <SimulationLibrarySidebar
              filterOptions={filterOptions}
              selectedFilters={selectedFilters}
              search={search}
              isShowLastTwelveMonths={isShowLastTwelveMonths}
              onSearchInput={handleSearchInput}
              onSearch={handleSearch}
              onFilterClick={handleFilterClick}
              onChangeLastMonth={handleChangeLastMonth}
            />
            <div className="simulations">
              {sims.length < 1 && !loading ? (
                <h3 className="title">No simulation exist.</h3>
              ) : (
                sims.map((data) => (
                  <SimulationCard
                    key={data.simId}
                    data={data}
                    detailPath={(simId) => `/simulations/detail/${simId}`}
                    actionLabel="View Details »"
                    showAction={(sim) => sim.hasAccess}
                  />
                ))
              )}
              {loadingMore && (
                <div className="overlay">
                  <Loader loading={true} />
                </div>
              )}
            </div>
          </section>
        </div>

        {loading && (
          <div className="overlay">
            <Loader loading={loading} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ListPublicSimulations;
